<div class="frame-in">
  @if (fullData) {
    <div [ngClass]="{'hidden': loading}" >
      <div class="introduction" [ngClass]="{'hidden':!(!gameStatus || gameStatus == 'introduction')}">
        <h2 class="title">
          <span class="main-text">{{fullData.introduction.title}}</span>
          <span class="bg-text">{{fullData.introduction.title}}</span>
        </h2>
        <p class="text">{{fullData.introduction.text}}</p>
        <button type="button" class="introduction-button" (click)="gameStart()"></button>
        <button type="button" class="introduction-audio-button"  [ngClass]="{'ios': ios && !userTouch}" (click)="playIntroductionAudio()"></button>
      </div>
      @if (gameStatus && gameStatus == 'start') {
        <div class="dot-to-dot-box">
          <button type="button" class="leave-button" (click)="changeGameStatus('leave')"></button>
          <button type="button" class="done-button2" (click)="save()" [ngClass]="{'last': currentIndex == this.fullData.letters.length - 1}"></button>
          <h2 class="title-box"><span>{{data.data.title}} <small>{{data.data.arabicLetter}}</small></span></h2>
          <div class="main-box">
            <div class="left-side">
              <button type="button" class="sound-button" [ngClass]="{'pause': bgSoundPause}" (click)="playPause()"></button>
              <div class="brush-size" [ngClass]="{'active': selectedColor !== '#ffffff'}" >
                <div class="brush" (click)="brushSizeClick()"></div>
                <ul >
                  <!-- <li class="xl" [ngClass]="{'active': brushSize == 40}" (click)="brushSize = 40"></li> -->
                  <li class="l" [ngClass]="{'active': brushSize == 30}" (click)="brushSize = 30"></li>
                  <li class="m" [ngClass]="{'active': brushSize == 24}" (click)="brushSize = 24"></li>
                  <li class="s" [ngClass]="{'active': brushSize == 18}" (click)="brushSize = 18"></li>
                </ul>
              </div>
              <!-- <div class="eraser" (click)="eraserClick = !eraserClick"></div> -->
              <div class="eraser" [ngClass]="{'active': selectedColor == '#ffffff'}" (click)="eraserClick()"></div>
            </div>
            <div class="draw-box">
              @if (fullData.letters.length > 1) {
                <div class="current-letter">{{currentIndex+1}}</div>
              }
              <app-board [lineWidth]="brushSize" [bg]="data.data.paintBg" [color]="selectedColor"></app-board>
            </div>
            <div class="right-side">
              <img class="paint-example" [src]="data.data.paintExample" draggable="false">
              <ul class="color-box">
                <li [ngClass]="{'active': selectedColor == '#fc50a6'}" (click)="selectedColor = '#fc50a6'"></li>
                <li [ngClass]="{'active': selectedColor == '#f5a536'}" (click)="selectedColor = '#f5a536'"></li>
                <li [ngClass]="{'active': selectedColor == '#985921'}" (click)="selectedColor = '#985921'"></li>
                <li [ngClass]="{'active': selectedColor == '#fbfa52'}" (click)="selectedColor = '#fbfa52'"></li>
                <li [ngClass]="{'active': selectedColor == '#d7f036'}" (click)="selectedColor = '#d7f036'"></li>
                <li [ngClass]="{'active': selectedColor == '#6db938'}" (click)="selectedColor = '#6db938'"></li>
                <li [ngClass]="{'active': selectedColor == '#55c9fa'}" (click)="selectedColor = '#55c9fa'"></li>
                <li [ngClass]="{'active': selectedColor == '#1b57f8'}" (click)="selectedColor = '#1b57f8'"></li>
                <li [ngClass]="{'active': selectedColor == '#4a0cb1'}" (click)="selectedColor = '#4a0cb1'"></li>
                <li [ngClass]="{'active': selectedColor == '#920dbc'}" (click)="selectedColor = '#920dbc'"></li>
                <li [ngClass]="{'active': selectedColor == '#b51f54'}" (click)="selectedColor = '#b51f54'"></li>
                <li [ngClass]="{'active': selectedColor == '#f93c29'}" (click)="selectedColor = '#f93c29'"></li>
              </ul>
            </div>
          </div>
        </div>
      }
      <div class="leave" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'leave')}">
        <p class="text">{{data.leave.text}}</p>
        <div class="row justyfy-content-center">
          <div class="col-auto">
            <button type="button" class="leave-yes" (click)="previousState()"></button>
          </div>
          <div class="col-auto">
            <button type="button" class="leave-no" (click)="gameStart()"></button>
          </div>
        </div>
      </div>
      <div style="margin-right: -36px;" class="leave" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'save')}">
        <p class="text2">{{data.save.text}}</p>
        <div class="row justyfy-content-center">
          <div class="col-auto">
            <button type="button" class="save-ok" (click)="saveOk()"></button>
          </div>
        </div>
      </div>
      <div class="complete" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'complete')}">
        <div class="trophy"></div>
        <div class="total-score">{{userInfo?.totalScore}}</div>
        <div class="stars">+{{fullData.maxStars}}</div>
        <button type="button" class="back-to-menu" (click)="previousState()"></button>
        <button type="button" class="again" (click)="again()"></button>
        <button type="button" class="next-activity" (click)="nextActivity()"></button>
      </div>
      <audio id="completeAudio">
        <source [src]="fullData.completeAudios[fullData.completeAudios.length | randomIndex]" type="audio/wav">
      </audio>
      <audio id="colorHover">
        <source  src="assets/sounds/color-button.mp3" type="audio/mpeg">
      </audio>
      <audio id="imageSaveAudio">
        <source  src="assets/sounds/image-saved.mp3" type="audio/mpeg">
      </audio>
      <audio id="warningAudio">
        <source  src="assets/sounds/warning.mp3" type="audio/mpeg">
      </audio>
      <audio id="introductionAudio" (loadeddata)="instructionLoaded()">
        <source [src]="fullData.introduction.audio" type="audio/wav">
      </audio>
      @if (data.introduction) {
        <audio id="letterIntroAudio" (ended)="playBgAudio()">
          <source [src]="data.introduction.audio" type="audio/wav">
        </audio>
      }
      <audio loop id="bgAudio">
        <source [src]="data.data.bgAudio" type="audio/wav">
      </audio>
      <img class="frame-bg" src="assets/images/activity/introduction/introduction-bg.jpg" [ngClass]="{'hidden':gameStatus && gameStatus !== 'introduction'}">
      <img class="frame-bg" src="assets/images/activity/dot-to-dot/dot-to-dot-bg.jpg" [ngClass]="{'hidden': !gameStatus || gameStatus !== 'start'}">
      <img class="frame-bg" src="assets/images/activity/complete/complete-bg.png" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'complete'}">
      <img class="frame-bg" src="assets/images/activity/leave/leave-bg.png" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'leave'}">
      <img class="frame-bg" src="assets/images/activity/dot-to-dot/save-bg.jpg" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'save'}">
    </div>
  }



</div>

